import $api from 'http';

export async function getDriverLastLoadA(uid) {
  return $api.get(`/tabel/driver-last-load-a/${uid}/`);
}

export async function postLoadMarkBGuard(load_id, payload) {
  return $api.post(`/tabel/load-mark-b-guard/${load_id}/`, payload);
}

export async function putLoadMarkB(load_id, formData) {
  return $api.put(`/tabel/load-mark-b-operator/${load_id}/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export async function getLoadsByTopBase(top_base_id) {
  return $api.get(`/tabel/loads-by-topbase/${top_base_id}/`);
}
